import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import CONFIG from "./config";
import bdapi from "@bd-core/bd-api";

/**
 * @typedef {Window & { screenCalculationFunc?: () => void }} ExtendedWindow
 */

const GameLogic = {
    transitionDuration: 0,
    initialized: false,
    currentPageType: undefined,
    currentPageID: false,

    async init() {
        if ($(".app").length < 1) return false;

        let currentPageId = CONFIG.game.current_page;

        this.initializePage(currentPageId, true);
        this.registerGlobalEvents();
    },

    registerGlobalEvents() {
        $(document).on("click", "[data-change-page]", this.changePage.bind(this));

        $(window).on("resize", () => {
            const isFunction =
                typeof /** @type {ExtendedWindow} */ (window).screenCalculationFunc === "function";
            if (isFunction) /** @type {ExtendedWindow} */ (window).screenCalculationFunc();
        });
    },

    changePage(e) {
        const $el = $(e.currentTarget);
        const pageId = $el.attr("data-change-page");
    
        this.goToPage(pageId);
    },

    goToPage(pageId) {
      if(this.currentPageID === pageId) return;
    
        bdjs.showLoading();
        $(".site").removeClass("overlay-opened");
    
        setTimeout(() => {
          this.initializePage(pageId);
        }, this.transitionDuration);
    },

    async initializePage(pageId, dontUpdate) {
        pageId = isNaN(parseInt(pageId)) ? pageId : parseInt(pageId);
    
        const pageData = this.getPageData(pageId);
        const component = bdjs.getComponent(pageData.type);
    
        if (component) {
          if (this.currentPageType) {
            const prevComponent = bdjs.getComponent(this.currentPageType);
    
            if (prevComponent) {
              prevComponent.destroy();
            }
          }

          this.currentPageType = pageData.type;
          this.currentPageID = pageId;
          CONFIG.game.current_page = pageId;

          component._setData(pageId, pageData.data);
          component.init();
    
          if (!dontUpdate) {
            // update page id to server
            await bdjs.goAsync(bdapi.post("game/change-page", {
              page_id: pageId,
            }));
          }
    
          this.listenScreenLoading();
        } else {
          console.error("Component: Can't find component " + pageData.type);
        }
    },

    getPageData(pageId) {
        let _data = {};
    
        /**
         * @type {string | undefined}
         */
        let _type = undefined;
    
        $.each(CONFIG.game.pages, (index, room) => {
          if (room.id == pageId) {
            _type = room.type;
            _data = room.data;
            return false;
          }
        });
    
        return {
          type: _type,
          data: _data,
        };
    },

    listenScreenLoading() {
        const $screenImg = $(".screen__img");
        const isScreenImgExist = $screenImg.length > 0;
    
        const onLoaded = () => {
          const isFunction = typeof /** @type {ExtendedWindow} */ (window).screenCalculationFunc === "function";
    
          if (isScreenImgExist) {
            if (isFunction) /** @type {ExtendedWindow} */ (window).screenCalculationFunc();
          }
    
          setTimeout(() => {
            bdjs.hideLoading();
          }, this.transitionDuration);
        };
    
        if (!isScreenImgExist) return onLoaded();
        if ($screenImg[0].complete) return onLoaded();
        $screenImg.on("load", onLoaded);
        $screenImg.on("error", onLoaded);
    },
};

export default GameLogic;
